import type { CosTheme } from '@cosmos/types-common';

export abstract class ThemeSelectConfig {
  options?: CosTheme[];
}
